/**
 * Hide Backdrop Action
 * Uses the existing runToggleBackdrop with action='hide' and unique event ID targeting
 */

import { runBackdropToggle } from './runBackdropToggle.jsx';

export const runBackdropHide = async (data = {}) => {
  try {
    const { eventId, targetEventId, ...otherData } = data;

    // Use targetEventId as selector if provided, otherwise use eventId
    const selector = targetEventId ? `#${targetEventId}` : eventId ? `#${eventId}` : '.backdrop';

    return await runBackdropToggle({
      action: 'hide',
      selector,
      ...otherData
    });
  } catch (error) {
    console.error('Hide backdrop error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runBackdropHide;
